var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap gap-3 md:gap-2"},_vm._l((_vm.tags),function(item){return _c('AtomTag',{key:item.name,staticClass:"bg-white !border-white",attrs:{"content":item.name,"tag":"span"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }